import React, { useState } from 'react';
import CertificateItem from './CertificateItem';
import { certificates } from './data.js';
import DownIcon from '../../assets/down-arrow4.svg';
import styles from './styles.module.scss';
// import { style } from 'dom-helpers';

function CertificateField(props) {
	const [isShown, setIsShown] = useState(false);

	return (
		<>
			<div
				className={styles.certificateFieldHeader}
				onClick={() => setIsShown(!isShown)}
			>
				<h4>{props.type}</h4>
				<img
					src={DownIcon}
					alt=''
					className={`${isShown ? styles.upArrow : styles.downArrow}`}
				/>
			</div>
			<>
				{isShown
					? certificates
							.filter((certificate) => certificate.type === props.type)
							.map((certificate) => (
								<CertificateItem
									title={certificate.title}
									date={certificate.date}
									link={certificate.link}
									courseLink={certificate.courseLink}
								/>
							))
					: null}

				{isShown ? <br /> : null}
			</>
		</>
	);
}

export default CertificateField;
